module.exports = __webpack_public_path__ + "static/short-and-sweet-a57e1fb7b7eb4ba5f52e519e8831c9a5.png";